

import PricingTabButtonsEx from "@/components/main/pricingExample/PricingTabButtonsEx"


import DatingTab from "@/components/main/pricingExample/content/DatingTab";
import SocialTab from "@/components/main/pricingExample/content/SocialTab";
import ListingLocatorTab from "@/components/main/pricingExample/content/ListingLocatorTab";
import CamStreamsTab from "@/components/main/pricingExample/content/CamStreamsTab";
import XXXTab from "@/components/main/pricingExample/content/XXXTab";
import TinderTab from "@/components/main/pricingExample/content/TinderTab";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import FormSelect from "@/components/main/forms/FormSelect";

export default {
  name: "PricingSectionEx",
  components: {TinderTab, PricingTabButtonsEx, DatingTab, SocialTab, ListingLocatorTab, CamStreamsTab, XXXTab, RedHeadBox, FormSelect },
  data() {
    return {
      currentTab: 1,
      products: [
        {
          name: 'DATING/ALTERNATIVE LIFESTYLES SITES',
          id: 1
        },
        {
          name: 'SOCIAL MEDIA & MOBILE CHAT/HOOK-UP APPS',
          id: 2
        },
        {
          name: 'LISTING LOCATOR',
          id: 3
        },
        {
          name: 'LIVE ADULT STREAMS',
          id: 4
        },
        {
          name: 'XXX WEBSITES',
          id: 5
        },
        {
          name: 'TINDER BLASTER',
          id: 6
        }
      ]
    }
  },
  computed: {
    thisTab() {
      switch(this.currentTab) {
        case 1: {
          return DatingTab;
        }

        case 2: {
          return SocialTab;
        }

        case 3: {
          return ListingLocatorTab;
        }

        case 4: {
          return CamStreamsTab;
        }

        case 5: {
          return XXXTab;
        }

        case 6: {
          return TinderTab;
        }
      }
    }
  },
  methods: {
    change(data) {
      this.currentTab = data
    }
  },
}
